import '@mantine/core/styles.css';
import { createTheme, MantineProvider } from '@mantine/core';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.scss';
import App from './components/App/App';
import reportWebVitals from './reportWebVitals';

const theme = createTheme({
  primaryColor: 'orange',
  fontFamily:
    'Barlow, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  /** Slightly larger than Mantine defaults for better readability */
  fontSizes: {
    xs: '0.8125rem',
    sm: '0.9375rem',
    md: '1.0625rem',
    lg: '1.1875rem',
    xl: '1.3125rem',
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <React.StrictMode>
    <MantineProvider defaultColorScheme="light" theme={theme}>
      <App />
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
